import { useMutation, useQueryClient } from "@tanstack/react-query";

import { AuthApi } from "../api/authApi";

export const useSignInWithOTPMutation = () => {
  return useMutation({
    mutationFn: (email: string) => AuthApi.signInWithOtp(email),
  });
};

export const useVerifyOTPMutation = () => {
  return useMutation({
    mutationFn: ({ email, otp }: { email: string; otp: string }) =>
      AuthApi.verifyOtp({ email, otp }),
  });
};

export const useSignOutMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => AuthApi.signOut(),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};
